import { Endpoint } from '../endpoint';
import { ProjectPriorityRequest, ProjectPriorityResponse } from './../../entities/project/ProjectPriorityResponse';

export function fetchProjectPriorities() {
  return Endpoint.get<ProjectPriorityResponse[]>('@gc/project/board/priorities');
}

export function fetchProjectPriority(id: string) {
  return Endpoint.get<ProjectPriorityResponse>(`@gc/project/board/priority/${id}`);
}

export function createProjectPriority(data: ProjectPriorityRequest) {
  return Endpoint.post<ProjectPriorityResponse>(`@gc/project/board/priority`, { data });
}

export function updateProjectPriority(id: string, data: ProjectPriorityRequest) {
  return Endpoint.patch<ProjectPriorityResponse>(`@gc/project/board/priority/${id}`, { data });
}

export function deleteProjectPriority(id: string) {
  return Endpoint.delete<void>(`@gc/project/board/priority/${id}`);
}

export function defaultProjectPriority(id: string) {
  return Endpoint.post<ProjectPriorityResponse[]>(`@gc/project/board/default-priority/${id}`);
}

export function removeDefaultProjectPriority(id: string) {
  return Endpoint.post<ProjectPriorityResponse[]>(`@gc/project/board/remove-default-priority/${id}`);
}
